import { withI18n } from 'react-i18next';
import MobileInvoiceCard from './MobileInvoiceCard';

export const pureComponent = MobileInvoiceCard;
export default withI18n()(MobileInvoiceCard);
